<h2 mat-dialog-title>
  <div class="dialog-title" fxLayout="column" fxLayoutAlign="space-between" fxFlex="100">
    <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
      <span>{{ data.item.name }}</span>
      <mat-icon (click)="reference?.close()">close</mat-icon>
    </div>
    <span class="subtitle">{{ sizeDescriptions[data.item.size] }}</span>
  </div>
</h2>

<div mat-dialog-content style="padding-top: 30px">
  <h4>Description</h4>
  <p class="description-txt">
    {{ data.item.description }}
  </p>
  @if (data.item.size === 'xlarge') {
    <div>
      <h4>Disassembly options</h4>
      <mat-radio-group [(ngModel)]="disassembly" name="disassemblyOptions" ngDefaultControl class="disassembly-radio-group">
        <mat-radio-button class="disassembly-option" [value]="true" labelPosition="before">
          <div class="option-content">
            <div class="option-title">Let Resupply Disassemble</div>
            <div class="option-subtitle">Resupply does offer professional disassembly for a fee</div>
          </div>
        </mat-radio-button>

        <mat-radio-button class="disassembly-option" [value]="false" labelPosition="before">
          <div class="option-content">
            <div class="option-title">No disassembly needed</div>
            <div class="option-subtitle">free</div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  }

  <div class="actions" fxLayout="row" fxLayoutAlign="space-between">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
      <span class="label no-mobile">Quantity</span>
      <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
        <div class="counter-btn" (click)="removeItem()" [ngClass]="{ disabled: count === 1 }">
          <mat-icon>remove</mat-icon>
        </div>
        <input type="tel" [(ngModel)]="count" (input)="handleQuantityChangeThroughInput($event)" />
        <div class="counter-btn" (click)="addItem()">
          <mat-icon>add</mat-icon>
        </div>
      </div>
    </div>
    <button class="primary-btn filled-btn" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" (click)="submit()">
      Add
      <mat-icon svgIcon="ss3-arrow-right" />
    </button>
  </div>
</div>
